import {Box, Text} from '@chakra-ui/react'
import {Link} from '@cypro/ui/components/ui/link'
import {getShortDateFormatterUTC, isDefined} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'

interface DuplicatePatient {
  id: string
  familyName: string
  givenName: string
  birthDate?: number | null
}

/** Shown under an identifier field when another patient already uses the same number. */
export function DuplicatePatientNotice({patient}: {patient: DuplicatePatient | undefined}) {
  const {t} = useTranslate('patients')
  if (!patient) return null

  const details = [
    patient.familyName,
    patient.givenName,
    isDefined(patient.birthDate) ? getShortDateFormatterUTC().format(new Date(patient.birthDate)) : null,
  ]
    .filter(Boolean)
    .join(', ')

  return (
    <Box marginTop="1.5" fontSize="xs" color="fg.error" data-testid="duplicate-patient-notice">
      <Text>{t('duplicate_identifier.message')}</Text>
      <Text>
        {t('duplicate_identifier.patient')}{' '}
        <Link
          to="/patient-dashboard/patients/$patientId"
          params={{patientId: patient.id}}
          target="_blank"
          color="inherit"
          textDecoration="underline"
        >
          {details}
        </Link>
      </Text>
    </Box>
  )
}
